import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import icons from "./Icons.js";
import Box from "@mui/material/Box";
import Tooltip from "../Tooltip/Tooltip.js";
const CellIcon = (t0) => {
  const $ = c(21);
  const {
    type
  } = t0;
  let iconComponent;
  bb0: switch (type) {
    case "Facebook Ads": {
      let t12;
      if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.FacebookAds, {});
        $[0] = t12;
      } else {
        t12 = $[0];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Google Ads": {
      let t12;
      if ($[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.GoogleAds, {});
        $[1] = t12;
      } else {
        t12 = $[1];
      }
      iconComponent = t12;
      break bb0;
    }
    case "LinkedIn Ads": {
      let t12;
      if ($[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.LinkedInAds, {});
        $[2] = t12;
      } else {
        t12 = $[2];
      }
      iconComponent = t12;
      break bb0;
    }
    case "TikTok Ads": {
      let t12;
      if ($[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.TiktokAds, {});
        $[3] = t12;
      } else {
        t12 = $[3];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Instagram Ads": {
      let t12;
      if ($[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.InstagramAds, {});
        $[4] = t12;
      } else {
        t12 = $[4];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Microsoft Advertising (Bing)":
    case "Microsoft Ads": {
      let t12;
      if ($[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.MicrosoftAds, {});
        $[5] = t12;
      } else {
        t12 = $[5];
      }
      iconComponent = t12;
      break bb0;
    }
    case "MetaAds":
    case "Meta Ads": {
      let t12;
      if ($[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.MetaAds, {});
        $[6] = t12;
      } else {
        t12 = $[6];
      }
      iconComponent = t12;
      break bb0;
    }
    case "DV360": {
      let t12;
      if ($[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.DV360, {});
        $[7] = t12;
      } else {
        t12 = $[7];
      }
      iconComponent = t12;
      break bb0;
    }
    case "ChatGPT":
    case "chatgpt.com":
    case "openai.com":
    case "ChatGPT Ads":
    case "chatgpt_gui": {
      let t12;
      if ($[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.ChatGPT, {});
        $[8] = t12;
      } else {
        t12 = $[8];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Gemini":
    case "gemini.google.com":
    case "Google AI Overview":
    case "google_ai_overview":
    case "google_gemini_gui": {
      let t12;
      if ($[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.Gemini, {});
        $[9] = t12;
      } else {
        t12 = $[9];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Claude":
    case "claude.ai":
    case "anthropic.com":
    case "anthropic_claude_4_5_haiku": {
      let t12;
      if ($[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.Claude, {});
        $[10] = t12;
      } else {
        t12 = $[10];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Deepseek":
    case "DeepSeek":
    case "deepseek.com": {
      let t12;
      if ($[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.Deepseek, {});
        $[11] = t12;
      } else {
        t12 = $[11];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Perplexity":
    case "perplexity.ai":
    case "perplexity.com": {
      let t12;
      if ($[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.Perplexity, {});
        $[12] = t12;
      } else {
        t12 = $[12];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Microsoft Copilot":
    case "copilot.microsoft.com":
    case "Bing Copilot": {
      let t12;
      if ($[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.MicrosoftCopilot, {});
        $[13] = t12;
      } else {
        t12 = $[13];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Huggingface":
    case "Hugging Face":
    case "huggingface.co": {
      let t12;
      if ($[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.Huggingface, {});
        $[14] = t12;
      } else {
        t12 = $[14];
      }
      iconComponent = t12;
      break bb0;
    }
    case "writesonic.com":
    case "writesonic.ai":
    case "Writesonic": {
      let t12;
      if ($[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.Writesonic, {});
        $[15] = t12;
      } else {
        t12 = $[15];
      }
      iconComponent = t12;
      break bb0;
    }
    case "copy.ai":
    case "Copy.ai": {
      let t12;
      if ($[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.CopyAi, {});
        $[16] = t12;
      } else {
        t12 = $[16];
      }
      iconComponent = t12;
      break bb0;
    }
    case "Google AI Mode":
    case "google_ai_mode_gui": {
      let t12;
      if ($[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
        t12 = /* @__PURE__ */ jsx(icons.GoogleAiMode, {});
        $[17] = t12;
      } else {
        t12 = $[17];
      }
      iconComponent = t12;
      break bb0;
    }
    default: {
      iconComponent = null;
    }
  }
  let t1;
  if ($[18] !== iconComponent || $[19] !== type) {
    t1 = iconComponent ? /* @__PURE__ */ jsx(Tooltip, { title: type, children: /* @__PURE__ */ jsx(Box, { sx: {
      width: 20,
      height: 20
    }, children: iconComponent }) }) : null;
    $[18] = iconComponent;
    $[19] = type;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  return t1;
};
export {
  CellIcon as default
};
